import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModuleDocumentTemplateService } from './services/module-document-template.service';

@NgModule({
    imports: [CommonModule],
    providers: [
        ModuleDocumentTemplateService,
    ],
})
export class DataServicesModule {}
